@if (showLabel) {
  <label
    soho-label
    [required]="required$ | async"
    attr.for="{{id}}"
    [layoutInfo]="layoutInfo"
    lm-label
    [layoutField] = "field"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [personalize]="personalize && !field?.label?.textStyle?.color"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
}
<div soho-rating
  #sohoRating
  (click)="onChangeRating($event)"
  (focusout)="onFieldBlur($event)">
  <fieldset>
    @for (option of ratingOptions; track option; let i = $index) {
      <input
        type="radio"
        [ngClass]="option.class"
        name="{{ratingName}}"
        id="{{option.id}}"
        value="{{i}}">
        <label for="{{option.id}}">
          <svg #OptionSVG class="icon" focusable="false" aria-hidden="true" role="presentation">
            <use [attr.xlink:href]="option.href"></use>
          </svg>
          <span class="audible">{{option.label}}</span>
        </label>
      }
    </fieldset>
  </div>
  <ng-template #mouseOverTextTemplate>
    @if (layoutObject.mouseOverText) {
      <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
    }
  </ng-template>

  <span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>